<template>
    <div class="bi-content">
        <div class="bi-content-top">
            <div class="opera-tit-btn">
                <div class="btn"><el-button type="primary" @click="saveData">保存配置</el-button></div>
            </div>
            <div class="form-data">
                <el-form class="float:left" size="mini" label-width="100px">
                    <el-row>
                        <el-col :span="6">
                          <el-form-item label="数据来源">
                                <el-radio-group v-model="BIDimension" @change="initFormList" :disabled="canChoose">
                                     <el-radio-button :label="0" :disabled="canChoose">表单</el-radio-button>
                                     <el-radio-button :label="2" :disabled="canChoose">报表</el-radio-button>
                                     <el-radio-button :label="6"  :disabled="canChoose">聚合表</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="数据源">
                                 <TreeSelect
                                     placeholder="请选择数据源"
                                     ref="treeSelect"
                                     :multiple="false"
                                     :disableBranchNodes="true"
                                     :sourceOptions="appModelsOptions"
                                     @treeSelectChoose="treeSelectChoose"
                                 />
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                          <el-form-item label="分类方式">
                               <el-select v-model="selectXdata" :disabled="isCanSelect" clearable placeholder="请选择需要分类的字段" @change="changeXdata"  style="width: 100%;">
                                   <el-option
                                       v-for="(item, index) in XData"
                                       :key="index"
                                       :label="BIDimension === 2 ? '【' + item.formName + '】' + item.name : item.name"
                                       :value="item.id"
                                   ></el-option>
                               </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="分组统计项">
                              <el-select
                                  v-model="selectYdata"
                                  :disabled="isCanSelect"
                                  value-key="id"
                                  clearable
                                  placeholder="请选择需要分组统计的字段"
                                  @change="changeYdata"
                                  :multiple="yIsmultiple"
                                  style="width: 100%;"
                              >
                                  <el-option
                                      v-for="item in YData"
                                      :key="item.id"
                                      :label="BIDimension === 2 ? '【' + item.formName + '】' + item.name : item.name"
                                      :value="item.id"
                                  ></el-option>
                              </el-select>
                          </el-form-item>
                        </el-col>
                     </el-row>
                     <el-row v-if="allChooseYdata.length>0">
                        <div class="zb-item" v-for="(item,index) in allChooseYdata" :key="index">
                            <div class="item-field"><span class="field-name-border">【</span>
                                <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                  <span class="field-name">{{item.name}}</span>
                                </el-tooltip>
                            <span class="field-name">】</span></div>
                            <div class="item-calcul">
                                <el-select v-model="item.calculVal"  value-key="id" placeholder="请选择计算方式">
                                    <el-option v-for="i in opreaYdata" :key="i.id" :label="i.name" :value="i.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <!-- 搜索条件 -->
                        <div class="search-content">
                            <div class="search-content-btn" @click="chooseConditionFields()">过滤条件</div>
                        </div>
                     </el-row>
                </el-form>
            </div>
        </div>
        <el-dialog
            title="查询条件"
            append-to-body
            top="4vh"
            custom-class="search-box"
            :visible.sync="isShowSearchConditon">
               <SearchCondition
                   ref='searchConditon'
                   :conditionFields="conditionFields"
                   :style="'height:60vh;overflow:auto;'"
                   :isShowLeftModel="false"
                   :key="searchLoadTimer"
                   :class="'search-field-box'"
                   >
               </SearchCondition>
            <span slot="footer" class="dialog-footer">
                <el-button @click="celSetFormNew()">关闭</el-button>
                <el-button type="success" @click="subSetFormNew()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getApplicationModelTreeList, getBIFormConfigs, getFormFieldListByIds, getModelFormReportList } from '@/data-model';
import { isEmpty, cloneDeep } from 'lodash';
export default {
    name: 'BiConfig',
    props: {
        biConfigData: {
            type: Object,
            default: () => {
                return {
                    modelTit: '',
                    appId: '',
                    formId: '',
                    modelName: '',
                    remarks: '',
                    modelId: ''
                };
            }
        },
        fieldConfig: {
            type: Object
        }
    },
    data () {
        return {
            appModelsOptions: [],
            XData: [],
            YData: [],
            searchData: [],
            opreaYdata: [{id: 2, name: '计数统计'}, {id: 3, name: '加和统计'}, {id: 4, name: '平均统计'}],
            cakeData: [],
            selectXdata: '',
            selectYdata: '',
            selectSearchData: [],
            selectOpreaYdata: '',
            selectCakedata: '',
            isCanSelect: true,
            formData: {},
            BIDimension: 0,
            chartSettings: {},
            dashboardSetting: {},
            modelId: '',
            allChooseXdata: {},
            allChooseYdata: [],
            formId: '',
            initData: 0,
            id: '',
            yIsmultiple: false,
            canChoose: false,
            showDataSource: '0',
            isShowSearchConditon: false,
            conditionFields: [],
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: '',
                formId: ''
            },
            searchLoadTimer: '',
            tableColumns: []
        };
    },
    created () {
        this._initPage();
    },
    methods: {
        async _initPage () {
            let param = {
                currentPage: 1,
                pageSize: 100,
                state: 1,
                modelType: this.BIDimension
            };
            if (this.BIDimension < 2) {
                param.aopModelType = 1;
            }
            let modelTree = await getApplicationModelTreeList(param);
            this.appModelsOptions = modelTree;
            if (!isEmpty(this.fieldConfig)) { // 修改
                if (this.fieldConfig.conditionFields) {
                    let search = cloneDeep(this.fieldConfig.conditionFields);
                    this.conditionFields = JSON.parse(search);
                }
                this.$refs.treeSelect.initParam(this.fieldConfig.dataModelId);
                this.initData = 1;
                let o = JSON.parse(this.fieldConfig.dashboardSetting);
                this.selectYdata = o.fieldIds[0];
                this.selectXdata = o.groupField.id;
                this.allChooseXdata = o.groupField;
                this.allChooseYdata = [];
                for (let i = 0; i < o.fieldIds.length; i++) {
                    // let showType = 0;
                    // if (o.fieldType[i] === 'number') {
                    //     showType = 1;
                    // }
                    let currentData = { id: o.fieldIds[i], name: o.field[i], type: o.fieldType[i], calculVal: o.calculVal[i], alias: o.alias[i] };
                    this.allChooseYdata.push(currentData);
                }
                this.modelId = this.fieldConfig.modelId;
            }
        },
        initFormList () {
            this._initPage();
        },
        initSelectData () {
            this.selectXdata = '';
            this.selectYdata = '';
            this.selectCakedata = '';
        },
        treeSelectChoose (selected) {
            // 选择好数据源后
            if (selected) {
                this.formId = selected.formId;
                this.modelId = selected.id;
                this.initField(selected);
                if (this.initData === 0) {
                    this.initSelectData();
                } else {
                    this.initData = 0;
                }
            } else {
                this.formData = {};
                this.isCanSelect = true;
                this.selectXdata = '';
                this.selectYdata = '';
                this.searchData = '';
            }
        },
        async initField (selected) {
            var param = { formId: selected.formId, BIDimension: this.BIDimension };
            let field = await getBIFormConfigs(param);
            this.isCanSelect = false; // 解锁字段展现列表
            this.XData = field.allList;
            this.YData = field.allList;
            this.searchData = field.allList;
            this.cakeData = field.allList;
            this.formData = selected;
        },
        changeYdata (e) {
            this.catchYData = this.allChooseYdata;
            this.allChooseYdata = [];
            if (e instanceof Array) {
                for (var j = 0; j < e.length; j++) {
                    let yobj = this.catchYData.find(y => y.id === e[j]);
                    if (yobj) {
                        this.allChooseYdata.push(yobj);
                    } else {
                        let list = this.YData.find(i => i.id === e[j]);
                        let showType = 0;
                        if (list.type === 'number') {
                            showType = 1;
                        }
                        let currentData = { id: e[j], name: list.name, type: list.type, calculVal: '', alias: '', showType: showType };
                        this.allChooseYdata.push(currentData);
                    }
                }
            } else {
                let list = this.YData.find(i => i.id === e);
                let showType = 0;
                if (list.type === 'number') {
                    showType = 1;
                }
                let currentData = { id: e, name: list.name, type: list.type, calculVal: '', alias: '', showType: showType };
                this.allChooseYdata.push(currentData);
            }
        },
        changeXdata (e) {
            // 拿到X轴的数据,然后更新展示数据,目前X轴就一条数据后期多了再改造
            let list = this.XData.find(i => i.id === e);
            let currentData = { id: e, name: list.name, type: list.type };
            this.allChooseXdata = currentData;
        },
        buildParams () {
            // 参数统一在此构造
            let param = {};
            let dashboardSetting = {};
            dashboardSetting.field = [];
            dashboardSetting.fieldIds = [];
            dashboardSetting.fieldType = [];
            dashboardSetting.calculVal = [];// 计算规则
            dashboardSetting.alias = [];// 别名
            dashboardSetting.groupField = this.allChooseXdata;
            for (var i = 0; i < this.allChooseYdata.length; i++) {
                var name = this.allChooseYdata[i].name;
                var id = this.allChooseYdata[i].id;
                var type = this.allChooseYdata[i].type;
                var calculVal = this.allChooseYdata[i].calculVal;// 计算规则
                if (!calculVal || calculVal === '') {
                    calculVal = 2;
                }
                var alias = this.allChooseYdata[i].alias;// 别名
                if (!alias || alias === '') {
                    alias = name;
                }
                dashboardSetting.field.push(name);
                dashboardSetting.fieldIds.push(id);
                dashboardSetting.fieldType.push(type);
                dashboardSetting.calculVal.push(calculVal);
                dashboardSetting.alias.push(alias);
            }
            param.dashboardSetting = JSON.stringify(dashboardSetting);
            param.dataFormId = this.formId;
            param.dataModelId = this.modelId;
            param.modelType = this.BIDimension;
            param.conditionFields = JSON.stringify(this.conditionFields);
            return param;
        },
        saveData () {
            let biData = this.buildParams();
            this.$emit('configStatisticsGroup', biData);
        },
        async renderFormList (model, isInitSearch, searchCondition) {
            this.searchParams.searchCondition = [];
            this.searchParams.modelId = model.dataModelId;
            this.searchParams.formId = model.dataFormId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = false;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: 1,
                pageSize: 10
            }, this.searchParams));
            this.refreshSearchConditon(this.tableColumns);
            loading.close();
            const loading1 = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            if (formData.otherData && formData.otherData.tableColumns) {
                this.tableColumns = [];
                let _tableColumns = formData.otherData.tableColumns;
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        this.tableColumns.push(item);
                    }
                });
            }
            this.refreshSearchConditon(this.tableColumns);
            loading1.close();
        },
        async refreshSearchConditon (columns) {
            this.conditionFields.length = 0;
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            let cfs = await getFormFieldListByIds(idArr.join(','));
            this.conditionFields = [];
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            if (cfs && cfs.length > 0) {
                for (var i = 0; i < cfs.length; i++) {
                    if (cfs[i].type === 'subform') {
                        continue;
                    } else {
                        this.conditionFields.push(cfs[i]);
                    }
                }
            }
            this.searchLoadTimer = new Date().getTime();
            this.isShowSearchConditon = true;
            loading.close();
        },
        chooseConditionFields () {
            if (this.conditionFields.length === 0) {
                let param = {dataModelId: this.modelId, dataFormId: this.formId};
                this.renderFormList(param, true, null);
            } else {
                this.isShowSearchConditon = true;
            }
        },
        subSetFormNew () {
            this.isShowSearchConditon = false;
        },
        celSetFormNew () {
            this.conditionFields = [];
            this.isShowSearchConditon = false;
        }
    }
};
</script>

<style lang="less" scoped="scoped">
.bi-content {
    // border: 1px solid #d6d4d7;
    height: 99%;
    width: 96%;
    top: 0vh;
    overflow: auto;
    position: absolute;
    .bi-content-top{
        .opera-tit-btn{
            display: flex;
            height:6vh;
            line-height: 6vh;
            .tit{
                flex: 1;
                font-size: 1.25rem;
                font-weight: 400;
                text-align: left;
            }
            .btn{
                flex: 1;
                text-align: right;
            }
        }
        .form-data{
            .zb-item{
                display: flex;
                width: 300px;
                height: 40px;
                line-height: 40px;
                margin-left: 20px;
                float: left;
                border: 2px dashed #bbb5b5;
                margin-bottom: 6px;
                .item-field{
                   width:90px;
                   display: flex;
                   .field-name{
                       display: inline-block;
                       text-overflow: ellipsis;
                       white-space: nowrap;
                       overflow: hidden;
                       cursor: pointer;
                   }
                   .field-name-border{
                       display: inline-block;
                   }
                }
                .item-calcul{
                   width: 190px;
                }
                .item-alias{
                   width: 190px;
                }
            }
            .search-content{
                height: 40px;
                line-height: 40px;
                .search-content-btn{
                    cursor: pointer;
                    color: #409eff;
                    padding-left: 20px;
                    float: left;
                }
            }
            .bi-type{
                display: flex;
                padding-left: 32px;
               .bi-type-item {
                   width: 58px;
                   height: 60px;
                   line-height: 60px;
                   float: left;
                   text-align: center;
                   img {
                       width: 30px;
                       height: 30px;
                       cursor: pointer;
                       margin-top: 10px;
                       padding: 5px;
                   }
                   img:hover {
                       width: 40px;
                       height: 40px;
                   }
                   .active {
                       border: 2px solid #009ed0;
                   }
               }
               .bi-tit{
                   width: 60px;
                   height: 60px;
                   line-height: 60px;
               }
               .bi-datasource-tit{
                   height: 60px;
                   line-height: 60px;
                   margin-left:20px;
               }
               .bi-datasource-data{
                   height: 60px;
                   line-height: 60px;
                   margin-left:20px;
               }
            }
        }
    }
    .bi-content-main{
        margin-top: 1vh;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/StatisticsGroup.vue